<template>
  <div>
    <CandidateApplicationIndexHeader/>
    <KanbanBoard
      :use-store="() => useCandidateApplicationStore()"
      :get-bucket-count="getBucketCount"
      :get-card-visibility="getApplicationVisibility"
      :match-items="store.state.steps.match"
      :connect-items="store.state.steps.connect"
      :status-filter="store.state.filterStatus"
      :hire-items="store.state.steps.hire"
      :loading="store.state.isLoading"
      card-type="Opportunity"/>
    <ModalCandidateCompany
      v-model:open="store.state.showOpportunity"
      :opportunity-id="store.state.selectedOpportunityId"
      :company-id="store.state.selectedCompanyId"
      :invite-id="store.state.selectedInviteId"
      allow-comparison
    />
  </div>
</template>

<script setup>
import ModalCandidateCompany from "../components/ModalCandidateCompany.vue";
import CandidateApplicationIndexHeader from "../components/CandidateApplicationIndexHeader.vue";
import KanbanBoard from "../components/KanbanBoard.vue";
import {useCandidateApplicationStore} from "../stores/CandidateApplicationStore.js";

const store = useCandidateApplicationStore();
store.index();

const disqualifiedAtIsPast = (application) => {
  return application.disqualified_at && new Date(application.disqualified_at) < new Date();
};

const getBucketCount = (applications) => {
  if (store.state.filterStatus === "All Applications") return applications.length;
  if (store.state.filterStatus === "Disqualified Only") return applications.filter((x) => disqualifiedAtIsPast(x)).length;
  if (store.state.filterStatus === "Withdrawn Only") return applications.filter((x) => x.withdrawn_at).length;
  if (store.state.filterStatus === "Unresponsive Only") return applications.filter((x) => x?.unresponsive_at).length;
  return applications.filter((x) => !disqualifiedAtIsPast(x) && !x.withdrawn_at && (!x?.opportunityInviteStatus || (x?.opportunityInviteStatus === "Pending"))).length;
};

const getApplicationVisibility = (application, filter) => {
  switch (filter) {
  case "All Applications":
    if (disqualifiedAtIsPast(application) || application.withdrawn_at || application?.opportunityInviteStatus === "Declined") return "opacity-50";
    return "";
  case "Disqualified Only":
    if (!disqualifiedAtIsPast(application)) return "hidden";
    return "opacity-80";
  case "Withdrawn Only":
    if (!application.withdrawn_at) return "hidden";
    return "opacity-80";
  case "Unresponsive Only":
    if (!application?.unresponsive_at) return "hidden";
    return "";
  default:
    return disqualifiedAtIsPast(application) || application.withdrawn_at || application?.opportunityInviteStatus === "Declined" ? "hidden" : "";
  }
};

const handleSearchParams = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const opportunityId = parseInt(searchParams.get("opportunity_id") ?? "0");
  const companyId = parseInt(searchParams.get("company_id") ?? "0");

  if (opportunityId) store.state.selectedOpportunityId = opportunityId;
  if (companyId) store.state.selectedCompanyId = companyId;

  store.state.showOpportunity = store.state.selectedOpportunityId > 0;
};

handleSearchParams();
</script>
